import { render, staticRenderFns } from "./CLAResponses.vue?vue&type=template&id=fbb0e6d4"
import script from "./CLAResponses.vue?vue&type=script&lang=js"
export * from "./CLAResponses.vue?vue&type=script&lang=js"
import style0 from "./CLAResponses.vue?vue&type=style&index=0&id=fbb0e6d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports